import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';

function AuthCallback() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const handleCallback = async () => {
      const token = searchParams.get('token');
      const error = searchParams.get('error');

      if (error) {
        console.error('Authentication error:', error);
        
        let errorMessage = 'Αποτυχία σύνδεσης';
        if (error === 'user_not_found') {
          errorMessage = 'Το email σας δεν έχει προστεθεί στο σύστημα. Επικοινωνήστε με τον διαχειριστή.';
        } else if (error === 'auth_failed') {
          errorMessage = 'Σφάλμα κατά την αυθεντικοποίηση. Δοκιμάστε ξανά.';
        }
        
        alert(errorMessage);
        navigate('/login');
        return;
      }

      if (token) {
        // Αποθήκευση token
        localStorage.setItem('token', token);

        try {
          // Λήψη user info
          const response = await axios.get('/auth/me');
          localStorage.setItem('user', JSON.stringify(response.data.user));
          
          // Redirect στο dashboard
          navigate('/dashboard');
        } catch (error) {
          console.error('Failed to fetch user info:', error);
          navigate('/login');
        }
      } else {
        navigate('/login');
      }
    };

    handleCallback();
  }, [searchParams, navigate]);

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      flexDirection: 'column',
      gap: '20px'
    }}>
      <div className="spinner" style={{
        border: '4px solid #f3f3f3',
        borderTop: '4px solid #2196F3',
        borderRadius: '50%',
        width: '50px',
        height: '50px',
        animation: 'spin 1s linear infinite'
      }}></div>
      <p>Σύνδεση σε εξέλιξη...</p>
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}

export default AuthCallback;
